import React from "react";
import spinner from "../../../../../public/images/icons/spinner.png";

import {
  makeStyles,
  createStyles,
  ButtonGroup,
  Button,
  TextField,
  Link,
  Typography
} from "@material-ui/core";
import { connect } from "react-redux";
import { IStoreState } from "../../Store";
import { ITheme } from "../../Layout/themes";

const useStyles = makeStyles(
  ({ palette, typography, breakpoints, transitions }: ITheme) => {
    return createStyles({
      "@keyframes spin": {
        "0%": {
          transform: "rotate(0deg)"
        },
        "100%": {
          transform: "rotate(360deg)"
        }
      },
      overlay: {
        zIndex: 1000,
        backgroundColor: "rgba(0,0,0,0.8)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        minHeight: "100vh",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
      },
      spinner: {
        opacity: 0.7,
        color: palette.primary.main,
        animation: `$spin 2500ms linear 200ms infinite`
      },
      text: {
        color: "#fff",
        marginTop: 25
      }
    });
  }
);

interface IProps {
  text: string;
  isLoading: boolean;
}

export const FullscreenLoader = ({ text = "", isLoading }: IProps) => {
  const classes = useStyles({});
  if (!isLoading) {
    return null;
  }
  return (
    <div className={classes.overlay}>
      <div className={classes.spinner}>
        <img src={spinner} alt="spinner" />
      </div>
      <Typography variant="h2" className={classes.text}>
        {text}
      </Typography>
    </div>
  );
};

const mapStateToProps = (state: IStoreState) => ({
  isLoading: state.fullscreenLoader.loading,
  text: state.fullscreenLoader.text
});

export const ConnectedFullscreenLoader = connect(mapStateToProps)(
  FullscreenLoader
);
